'use strict';

import BaseService from './base.service';

class AgenciesService extends BaseService {
  /* @ngInject */
  constructor(Agency, SegaUser) {
    super(Agency, SegaUser);
    Object.assign(this, {
      Agency
    });
  }
}

export default AgenciesService;
